import axiosInstance from './AxiosInstance';

export function sendNotificationsAPI(notificationData) {
    return axiosInstance.post(`/admin/user/notification`, notificationData);
}